/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MeAttachPhoneConfirmRequest
 */
export interface MeAttachPhoneConfirmRequest {
    /**
     * 
     */
    phone: string;
    /**
     * 
     */
    code: string;
}

/**
 * Check if a given object implements the MeAttachPhoneConfirmRequest interface.
 */
export function instanceOfMeAttachPhoneConfirmRequest(value: object): value is MeAttachPhoneConfirmRequest {
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function MeAttachPhoneConfirmRequestFromJSON(json: any): MeAttachPhoneConfirmRequest {
    return MeAttachPhoneConfirmRequestFromJSONTyped(json, false);
}

export function MeAttachPhoneConfirmRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeAttachPhoneConfirmRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'phone': json['phone'],
        'code': json['code'],
    };
}

export function MeAttachPhoneConfirmRequestToJSON(json: any): MeAttachPhoneConfirmRequest {
    return MeAttachPhoneConfirmRequestToJSONTyped(json, false);
}

export function MeAttachPhoneConfirmRequestToJSONTyped(value?: MeAttachPhoneConfirmRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phone': value['phone'],
        'code': value['code'],
    };
}

